module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: _vm.classes,
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7591139c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datepicker/datepicker.vue
// module id = 543
// module chunks = 84